const localSplitImage = value => typeof value === "string" && /^(?:\/img\/workout\/[a-zA-Z0-9_-]+\.(?:png|webp|jpe?g|svg)|\/img\/hyrox_logo\.png)$/.test(value)
const color = value => typeof value === "string" && /^#[a-f\d]{6}$/i.test(value) ? value : "#A3C6C4"

export function activitySplitVisual(activity) {
  if (activity?.kind === "course" || activity?.source === "group_fitness") return null
  // A linked Health recording keeps the image of the actual Roody execution.
  const execution = [activity, ...(activity?.members || [])].find(item =>
    item && item.kind !== "course" && !item.courseExecutionId && ["roody_v1", "roody_v2"].includes(item.source))
  if (!execution) return null
  const saved = execution.fixedVisualization
  if (localSplitImage(saved?.img)) return { img: saved.img, color: color(saved.color) }

  // Older executions did not save a visual. Use the same title fallback as the
  // split chooser; never guess a current plan/split by its mutable title.
  const title = String(execution.title || "").toLowerCase()
  if (title.includes("hyrox")) return { img: "/img/hyrox_logo.png", color: "#ffed00" }
  const options = [
    [["bein", "beine", "unterkörper", "leg", "lower body"], "legSplit.png", "#1C4966"],
    [["brust", "push", "chest"], "chestSplit.png", "#02734A"],
    [["rücken", "pull", "schulter", "back", "shoulder"], "backSplit.png", "#F2B950"],
    [["arm", "arme", "bizeps", "trizeps"], "armSplit.png", "#E5735D"],
    [["bauch", "core", "ober"], "cardioSplit.png", "#F7B5A7"],
  ]
  const match = options.find(([words]) => words.some(word => title.includes(word)))
  return { img: "/img/workout/" + (match?.[1] || "upperBodySplit.png"), color: match?.[2] || "#A3C6C4" }
}
